import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Dashboard } from './Pages/Dashboard';
import VideoPage from './Pages/VideoPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Dashboard/>} />
        <Route path="/:id" element={<VideoPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
